/**
 *  Avoid running the same function twice within the specified timeframe.
 */
export const debounce = (func: () => void, wait: number, immediate: boolean = false) => {
    let timeout: ReturnType<typeof setTimeout>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (this: any, ...args: any) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            clearTimeout(timeout);
            if (!immediate) {
                func.apply(context, args);
            }
        }, wait);
        if (immediate && !timeout) {
            func.apply(context, args);
        }
    };
};
